import React, { useEffect, useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { imageDetails } from "../slices/imageSlice";

const ModalPersistDesktop = ({
  show,
  handleClose,
  handlePersist,
  formData,
  setFormData,
  loadingDesktop,
  imageAttachments,
}) => {
  const dispatch = useDispatch();

  const [fetchedImageNames, setFetchedImageNames] = useState({});

  useEffect(() => {
    if (show && imageAttachments && imageAttachments.length > 0) {
      imageAttachments.forEach((attachment) => {
        if (attachment.imageId && !fetchedImageNames[attachment.imageId]) {
          dispatch(imageDetails(attachment.imageId))
            .unwrap()
            .then((response) => {
              if (response?.image?.name) {
                setFetchedImageNames((prev) => ({
                  ...prev,
                  [attachment.imageId]: response.image.name,
                }));
              }
            })
            .catch((error) => {
              console.error("Failed to fetch image details:", error);
            });
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, imageAttachments, dispatch]);

  const handleImageNameChange = (mountName, value) => {
    setFormData({
      ...formData,
      diskImagesNames: {
        ...formData.diskImagesNames,
        [mountName]: value,
      },
    });
  };

  return (
    <Modal show={show} onHide={handleClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>Persist Desktop</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <Form onSubmit={(e) => e.preventDefault()}>
          <Form.Group style={{ marginBottom: "15px" }}>
            <Form.Label>Template name</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter new template name"
              value={formData?.newTemplateName || ""}
              onChange={(e) =>
                setFormData({ ...formData, newTemplateName: e.target.value })
              }
            />
          </Form.Group>

          {imageAttachments && imageAttachments.length > 0 && (
            <div className="mt-4">
              <h6
                style={{
                  borderBottom: "1px solid #dee2e6",
                  paddingBottom: "5px",
                }}
              >
                Images
              </h6>
              {imageAttachments.map((attachment) => {
                const { imageId, mountName } = attachment;

                // Look up the dynamically fetched image name, fallback to ID if loading/not found
                const displayName = fetchedImageNames[imageId] || imageId;

                return (
                  <Form.Group
                    key={mountName}
                    style={{
                      marginBottom: "15px",
                      paddingLeft: "10px",
                      borderLeft: "3px solid #A3C1DA",
                    }}
                  >
                    <Form.Label>Image name:</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={`Enter new image name for ${displayName}`}
                      value={formData?.diskImagesNames?.[mountName] || ""}
                      onChange={(e) =>
                        handleImageNameChange(mountName, e.target.value)
                      }
                    />
                    <Form.Text className="text-muted" style={{ opacity: 0.7 }}>
                      Mount Name: {mountName}
                    </Form.Text>
                  </Form.Group>
                );
              })}
            </div>
          )}
        </Form>
      </Modal.Body>

      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Cancel
        </Button>
        <Button
          variant="primary"
          onClick={() => handlePersist(formData)}
          disabled={loadingDesktop}
        >
          {loadingDesktop ? (
            <Spinner animation="border" size="sm" />
          ) : (
            "Confirm"
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ModalPersistDesktop;
